import Blockly from 'blockly/browser'
import { defineStmtBlock, getOptionsCode } from '../Util'
import Mutators from '../Mutators'

Mutators.registerOptionsMutator('sirenia_notifications_options_mutator', {
  timeout: {
    type: 'Number',
    label: 'timeout (ms)'
  },
  callback: {},
  embed: {
    type: 'Boolean'
  },
  sound: {
    type: 'String'
  }
})

function defineNotificationBlock(verb) {
  defineStmtBlock(
    `sirenia_api_notifications_${verb}`,
    {
      message0: `${verb} %1 notification %2 with title %3 and message %4`,
      args0: [
        {
          type: 'field_dropdown',
          name: 'SEVERITY',
          options: [['info', 'INFO'], ['warning', 'WARN'], ['error', 'ERROR']]
        },
        {
          type: 'input_value',
          name: 'NAME',
          check: 'String'
        },
        {
          type: 'input_value',
          name: 'HEADER',
          check: 'String',
          align: 'RIGHT'
        },
        {
          type: 'input_value',
          name: 'MESSAGE',
          check: 'String',
          align: 'RIGHT'
        }
      ],
      tooltip: `${verb} a notification`,
      helpUrl:
        'http://sirenia.eu/product/configuration-interface/documentation/flows/#notifications',
      mutator: 'sirenia_notifications_options_mutator'
    },
    function(block) {
      const severity = block.getFieldValue('SEVERITY') || ''
      const name =
        Blockly.JavaScript.valueToCode(block, 'NAME', Blockly.JavaScript.ORDER_ATOMIC) || "''"
      const header =
        Blockly.JavaScript.valueToCode(block, 'HEADER', Blockly.JavaScript.ORDER_ATOMIC) || "''"
      const message =
        Blockly.JavaScript.valueToCode(block, 'MESSAGE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
      const optionsObject = getOptionsCode(
        this.chosenProps,
        block,
        severity !== 'INFO' ? { severity: `'${severity}'` } : null
      )
      return `Notification.${verb}(${name}, ${header}, ${message}, ${optionsObject});\n`
    }
  )
}

defineNotificationBlock('show')
defineNotificationBlock('update')

defineStmtBlock(
  'sirenia_api_notifications_close',
  {
    message0: 'close notification %1',
    args0: [
      {
        type: 'input_value',
        name: 'NAME',
        check: 'String'
      }
    ],
    tooltip: 'Close a named notification',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#notifications'
  },
  function(block) {
    var name =
      Blockly.JavaScript.valueToCode(block, 'NAME', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Notification.close(${name});\n`
  }
)
